import { components, useApi } from "@appretio/api";
import { keepPreviousData, useQuery } from "@tanstack/react-query";
import { ContextField } from "../contextConfig";
import { contextSelectorQueryKeys } from "./queryKeys";

export function useFilteredContextOptions({
  fields,
  filters,
  enabled
}: {
  fields?: ContextField[];
  filters?: components["schemas"]["ContextOptionsV2Input"]["filters"];
  enabled?: boolean;
}) {
  const client = useApi();

  return useQuery({
    queryKey: contextSelectorQueryKeys.list(
      JSON.stringify({ fields, filters })
    ),
    meta: {
      errorMessage: "Failed to fetch filtered context options"
    },
    queryFn: async () => {
      const response = await client.POST(
        "/v2/context-options/getContextOptions",
        {
          body: {
            fields: (fields || []) as components["schemas"]["ContextFieldV2"][],
            filters: filters || {}
          }
        }
      );

      const result = response.data?.result ?? {};

      // Transform null values to undefined to match expected type
      return Object.fromEntries(
        Object.entries(result).map(([key, value]) => [
          key,
          value === null ? undefined : value
        ])
      );
    },
    enabled: enabled,
    // Option list: the key changes on every filter click; keep the previous
    // options visible while the narrowed set fetches so the dropdowns don't
    // flash empty mid-interaction.
    placeholderData: keepPreviousData
  });
}
